import React, {useReducer, useRef} from 'react'
import {Modal, ModalActions, Button} from '@components/UI/index.js'
import {ColorPicker, FormRow, Input} from '@components/UI/forms/index.js'
import type {InputRef} from '@components/UI/forms/Input.js'
import {Reseller} from 'types/types.js'
import t from 'src/helpers/Languages'

type OwnOption = Reseller['settings']['orders']['customOptions'][number]

type OwnOptionModalProps = {
    onClose: () => void
    onSave: (OwnOption: OwnOption) => void
    option: OwnOption
}

type OwnOptionModalState = {
    option: OwnOption
}

function OwnOptionModal({onClose, onSave, option}: OwnOptionModalProps) {
    const [state, setState] = useReducer((state: OwnOptionModalState, newState: Partial<OwnOptionModalState>) => ({...state, ...newState}), {option})
    const inputRef = useRef<InputRef>(null)

    return (
        <Modal
            show
            onClose={onClose}
            closeButton
            title='Wijzig optie'
        >
            <FormRow>
                {'color' in option && (
                    <ColorPicker
                        value={state.option.color}
                        onChange={(event) => setState({option: {...state.option, color: event.target.value}})}
                    />
                )}

                <Input
                    id='ownOptionName'
                    label={t('name')}
                    value={state.option.name}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setState({option: {...state.option, name: event.target.value}})}
                    ref={inputRef}
                />
            </FormRow>

            <ModalActions style={{marginTop: 32}}>
                <Button onClick={() => {
                    if (!state.option.name) {
                        inputRef.current?.setInvalid(true)
                        return
                    }

                    onSave(state.option)
                }}
                >Opslaan
                </Button>
            </ModalActions>
        </Modal>
    )
}

export default OwnOptionModal
